import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useGlobalContext } from "context/global";
import { selectAndSaveBox, selectAndSaveFrequency } from "actions/cart";
import { ReactComponent as ArrowDown } from "assets/svgs/arrow-down-bold.svg";
import clsx from "clsx/lite";
import { useMemo } from "react";
import { toast } from "react-toastify";
import { setDeliveryFrequency } from "slices/cart";

const Frequency = ({ data }) => {
	const { cartSettings, translation } = useGlobalContext();
	const { delivery, mealsPerWeek, minBox } = useSelector((state) => state.cart);
	const dispatch = useDispatch();
	const selectedBox = useMemo(
		() => cartSettings.boxes.find(box => box.size.value === data.intervalCount * mealsPerWeek), [mealsPerWeek]
	);
	const isDisabled = !selectedBox || data.intervalCount * mealsPerWeek < minBox.size.value;

	const toastId = "frequency-error";

	const handleFrequency = (freq) => {
		if (isDisabled && !toast.isActive(toastId)) {
			return toast.error(
				translation.cart?.[selectedBox ? "remove_products_for_downgrade" : "meals_limited"],
				{
					toastId,
					icon: false, hideProgressBar: true, className: "bg-[#f8ece9] border border-[#d0331f]"
				});
		}

		dispatch(selectAndSaveFrequency(freq, cartSettings.subscription.frequencies));
		dispatch(selectAndSaveBox(selectedBox));
	};

	return (
		<button
			key={data._key}
			className={clsx(
				"border w-fit px-5 md:px-10 py-1.5 md:py-2 rounded-md",
				delivery?.value === data.value && "bg-[#362C27] text-white",
				isDisabled ? "opacity-50 border-secondary text-secondary" : "border-black"
			)}
			onClick={() => handleFrequency(data)}
		>
			{data.name}
		</button>
	);
};

const DeliveryFrequencies = ({ hideFrequencies = [], dropdown = false, className = "" }) => {
	const { cartSettings, translation } = useGlobalContext();
	const frequencies = cartSettings.subscription?.frequencies;

	const filteredFrequencies = frequencies?.filter(f => !hideFrequencies.includes(f.intervalCount));

	if (!filteredFrequencies?.length) return null;

	if (dropdown) return <FrequenciesDropdown frequencies={filteredFrequencies} className={className} />;

	return (
		<div className="flex flex-col items-center gap-3">
			<h4 className="font-body text-center">{translation.shopping_flow?.delivery_frequency_title}</h4>
			<div className="flex mx-auto gap-1.5">
				{filteredFrequencies.map(freq => <Frequency key={freq.value} data={freq} />)}
			</div>
		</div>
	);
};

const FrequenciesDropdown = ({ className, frequencies }) => {
	const dispatch = useDispatch();
	const { translation } = useGlobalContext();
	const { delivery } = useSelector((state) => state.cart);

	return (
		<div className={clsx("relative w-full md:w-fit", className, "mr-0")}>
			<div className="delivery-frequencies-container">
				<div className="flex gap-3">
					<span className="font-semibold">{translation.order?.delivery}: </span>
					<span>{delivery?.name}</span>
				</div>
				<ArrowDown role="presentation" aria-hidden="true" />
			</div>
			<div className="opacity-0 absolute z-10 top-0 w-full">
				<label htmlFor="delivery-frequency" className="sr-only">Delivery Frequency</label>
				<select
					id="delivery-frequency"
					value={delivery?.value ?? ""}
					className="select-option"
					onChange={(e) => {
						dispatch(setDeliveryFrequency(JSON.parse(e.target[e.target.selectedIndex].dataset.attrs)));
					}}
				>

					{frequencies.map((s) => (
						<option key={s.value} value={s.value} data-attrs={JSON.stringify(s)}>
							{s.name}
						</option>
					))}
				</select>
			</div>
		</div>
	);
};

export default DeliveryFrequencies;